import { useMemo } from 'react';
import { useFeatureToggle } from '@hotelplan/libs.feature-toggle';
import { FeatureList } from 'config/pageConfig.constants';
import { useFdrGetActiveWishlistQuery } from 'fdr/schemas/query/wishlist/fdr-get-active-wishlist.generated';
import { WishlistSource } from './fdr-wishlist.constants';

function checkWithHolidayFinder(items: { source?: string }[]): boolean {
  return items.some(item => item.source === WishlistSource.HF);
}

export function useHolidayFinderWishlistItem() {
  const { isEnabled } = useFeatureToggle();
  const wishlistContestEnabled = isEnabled(
    FeatureList.HOLIDAY_FINDER_CONTEST_WISHLIST
  );

  const { data, loading } = useFdrGetActiveWishlistQuery({
    ssr: false,
    skip: !wishlistContestEnabled,
  });

  const wishlistItems = useMemo(() => {
    return data?.fdrActiveWishlist.wishlist?.wishlistItems || [];
  }, [data]);

  return {
    withHolidayFinder: checkWithHolidayFinder(wishlistItems),
    loading,
  };
}
